import "./Cards.css";
import AOS from "aos";
import { useState } from "react";
import "aos/dist/aos.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea, Box, Grid } from "@mui/material";
import ModalComp from "../ModalComp/ModalComp";
import financeTrackerLogo from "../../images/fincance_tracker_logo.png";
import stoutzCustomzLogo from "../../images/stoutz_customz_logo copy.png";

export default function ActionAreaCard() {
  AOS.init();

  const [itemData, setItemData] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClick = (project) => {
    if (project.link) {
      window.open(project.link, "_blank");
    } else if (project.imageList.length > 0) {
      setItemData(project.imageList);
      setOpen(true);
    }
  };

  const portfolio = [
    {
      image: financeTrackerLogo,
      name: "Personal Finance Tracker",
      tech: "Next.js, TypeScript, Tailwind CSS, shadcn/ui, Supabase, FastAPI, BAML, Vercel AI SDK, Recharts, AWS Amplify",
      summary:
        "Full-stack personal finance app for managing loans, bills, income, properties, and bank transactions. Features AI-powered chat, CSV import with auto-categorization, and interactive spending charts.",
      link: "https://main.d10ss83radjelq.amplifyapp.com/login",
      imageList: [],
    },
    {
      image: stoutzCustomzLogo,
      name: "StoutzCustomz",
      tech: "Next.js, TypeScript, MUI, Framer Motion, React Hook Form, Zod",
      summary:
        "Professional website for an automotive body shop specializing in custom paint, collision repair, and vehicle restoration. Features smooth animations and a contact form.",
      link: "https://www.stoutzcustomz.com/",
      imageList: [],
    },
  ];

  return (
    <>
      {portfolio.map((project, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          key={index}
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Card
            sx={{
              width: '100%',
              maxWidth: 480,
              backgroundColor: 'rgba(33, 32, 32, 0.8)',
              backdropFilter: 'blur(10px)',
              borderRadius: 2,
              transition: 'all 0.3s ease-in-out',
              border: '1px solid rgba(114, 239, 221, 0.1)',
              '&:hover': {
                transform: 'translateY(-8px)',
              }
            }}
          >
            <CardActionArea onClick={() => handleClick(project)}>
              <Box sx={{
                position: 'relative',
                height: 220,
                overflow: 'hidden',
                borderRadius: '8px 8px 0 0'
              }}>
                <CardMedia
                  component="img"
                  image={project.image}
                  alt={project.name}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: "cover",
                  }}
                />
                <Box sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '60%',
                  background: 'linear-gradient(to top, rgba(33, 32, 32, 0.95) 0%, rgba(33, 32, 32, 0.4) 50%, transparent 100%)',
                  pointerEvents: 'none',
                }} />
              </Box>
              <CardContent sx={{ p: 3 }}>
                <Typography 
                  gutterBottom 
                  variant="h5" 
                  component="div" 
                  sx={{ 
                    fontWeight: "bold",
                    color: '#72efdd',
                    mb: 2
                  }}
                >
                  {project.name}
                </Typography>
                
                <Typography
                  variant="body2"
                  sx={{ 
                    color: 'white', 
                    mb: 3,
                    opacity: 0.9,
                    lineHeight: 1.6
                  }}
                >
                  {project.summary}
                </Typography>

                <Box sx={{ mb: 2 }}>
                  <Typography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#7E4DE2',
                      fontWeight: 'bold',
                      mb: 1
                    }}
                  >
                    Tech Stack:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'white',
                      opacity: 0.9,
                      lineHeight: 1.8,
                      pl: 1
                    }}
                  >
                    {project.tech}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
      {itemData && (
        <ModalComp itemData={itemData} setOpen={setOpen} open={open} />
      )}
    </>
  );
}
